import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

import { Foam } from '@usimweb/core/models';
import { Helper } from '@usimweb/core/services';

@Component({
    selector: 'app-material-dialog',
    templateUrl: './material-dialog.component.html',
    styleUrls: ['./material-dialog.component.scss'],
    standalone: false
})
export class MaterialDialogComponent implements OnInit {
  public data: Foam[] = [];

  public dataTableSource!: any[];
  public curveColumns: string[] = ['displayName', 'description', 'system'];
  public columnNames: string[] = ['Name', 'Description', 'System'];
  public filter: string = '';

  //public saveResponse = new BehaviorSubject(false);

  constructor(private dialogRef: MatDialogRef<MaterialDialogComponent>) {}

  ngOnInit(): void {
    this.creatTable();
  }

  private creatTable() {
    const array = [] as any;

    this.data.forEach((foam) => {
      array.push({
        displayName: foam.displayName,
        description: foam.description,
        system: Helper.Foam.getSystem(foam.group || ''),
      });
    });

    this.dataTableSource = array;
  }

  public save(row: any) {
    this.dialogRef.close(row.id);
  }

  public applyFilterMaterial(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
  }
}
